let nameRow = 'Bedrijfsnaam';
let addressRow = 'Afzender-adres';
let labelType = '30323';

function labelXml() {
	if (labelType === '30323') {
		// eslint-disable-next-line no-use-before-define
		return Dymo30323();
	} else if (labelType === '30321') {
		// eslint-disable-next-line no-use-before-define
		return Dymo30321();
	}
}

function Dymo30323() {
	let Dymo30323 = null;

	try {
		Dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/return/30323.xml');
	} catch (error) {
		Dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/return/30323.xml');
	}

	return Dymo30323;
}

function Dymo30321() {
	let Dymo30321 = null;

	try {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/return/30321.xml');
	} catch (error) {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/return/30321.xml');
	}

	return Dymo30321;
}

function createLabel() {
	const label = labelXml();

	label.setObjectText('returnName', nameRow);
	label.setObjectText('returnAddress', addressRow);

	return label;
}

export default {
	setName(newNameRow) {
		nameRow = newNameRow;
	},
	setAddress(newAddressRow) {
		addressRow = newAddressRow;
	},
	setLabelType(newLabelType) {
		labelType = newLabelType;
	},
	getLabel: createLabel,
}
